module.exports = __webpack_public_path__ + "static/img/tab2-map.0235437.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/tab2-map.png
// module id = 646
// module chunks = 12